import moment from 'moment';
import { firstValueFrom, timer, take } from 'rxjs';
import { getCurrentApiHost } from 'config/environment';
import { RoutePaths } from 'constant';
import { LANGUAGE_SELECT } from 'constant/constant';
import { ActiveTab, ApiKey, logger } from 'services';
import { TOKEN_EXPIRY_KEY } from 'services/api-key';
/**
 * Redirect after a short delay to give a little bit of time to save async logs
 */ const redirect = async (redirectUri)=>{
    await firstValueFrom(timer(moment.duration(1, 's').asMilliseconds()).pipe(take(1)));
    logger.debug('redirecting to', {
        redirectUri
    });
    window.location.href = `${window.location.origin}${redirectUri}`;
};
/**
 * Logs out the user from the current API and Okta session and redirects to a
 * provided page. If no redirect path is provided, the user is taken to
 * RoutePaths.login
 * @param redirectUri The local path to redirect to
 */ export const logout = async (redirectUri = RoutePaths.login)=>{
    logger.log('logging out');
    await ApiKey.clear();
    logger.debug('cleared api key');
    await fetch(`${getCurrentApiHost()}/api/v1/users/logout`, {
        method: 'POST',
        credentials: 'same-origin'
    });
    logger.debug('logged out by calling API');
    localStorage.removeItem(TOKEN_EXPIRY_KEY);
    localStorage.removeItem(LANGUAGE_SELECT);
    ActiveTab.clear();
    logger.debug('cleared active tab');
    // clear account meta from local storage
    localStorage.removeItem('accountMeta');
    /**
   * A redirect or window.location.reload() is recommended to ensure proper
   * re-initialization of app and okta auth sdk. Refer:
   * https://www.npmjs.com/package/@okta/okta-auth-js#closesession
   */ await redirect(redirectUri);
};
